export default __webpack_public_path__ + "static/media/hikaru-nakamura.5d952332.txt";